import { render, staticRenderFns } from "./PublicationTable.vue?vue&type=template&id=344a5618&"
import script from "./PublicationTable.vue?vue&type=script&lang=js&"
export * from "./PublicationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports